import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef } from "react";
import { TEXTAREA_SIZE_CLASSES, textareaClasses } from "./constants";
export const Textarea = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, rows = 3, size = "medium", hasError, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("textarea", {
        className: tailwindMerge(textareaClasses, TEXTAREA_SIZE_CLASSES[size], hasError && "!border-red-9 ring-1 !ring-red-9 focus:ring-red-9", className),
        ref: forwardedRef,
        rows: rows,
        ...restOfProps
    });
});
Textarea.displayName = "Textarea";
